/* eslint-disable no-prototype-builtins */
import Vue from 'vue'
import VueRouter from 'vue-router'
// import store from '../store/index.js'
import jwt from 'jsonwebtoken'
import QualityControl from '@/views/QualityControl.vue';
import Analyzers from '@/views/Analyzers.vue';
import { setTitleFromRoute } from '@/utils/titleHelper'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Main',
    // roles means needed role
    // user has to be in a team
    meta: { roles: ['user'] },
    component: () => import(/* webpackChunkName: "main" */ '../views/Videos.vue')
  },
  {
    path: '/videos',
    name: 'Videos',
    children: [],
    meta: { roles: ['user'], title: 'Videot' },
    component: () => import (/* webpackChunkName: "videos" */ '../views/Videos.vue'),
  },
  {
    path: '/data',
    meta: {
      roles: ['user'],
      title: 'Data',
      availableWithNoTeams: false,
    },
    component: () => import('../views/Data.vue'),
    children: [
      {
        path: 'league-times',
        name: 'LeagueTimes',
        meta: { title: 'Etenemisajat' },
        component: () => import('../views/LeagueTimes.vue'),
        props: { type: 'advancement' }
      },
      {
        path: 'made-outs',
        name: 'MadeOuts',
        meta: { title: 'Tehdyt palot' },
        component: () => import('../views/MadeOuts.vue')
      },
      {
        path: 'joukkueet',
        name: 'Joukkueet',
        meta: { title: 'Joukkueet' },
        component: () => import('../views/Joukkueet.vue')
      },
      {
        path: 'field-performance',
        name: 'FieldPerformance',
        component: () => import('../views/LeagueTimes.vue'),
        props: { type: 'field' }
      },
      {
        path: 'xrun',
        name: 'xRun',
        component: () => import('../views/Xrun.vue'),
        props: { type: 'field' }
      },
      // Add more data subpages here as needed
    ]
  },
  {
    path: '/games',
    name: 'Games',
    children: [],
    meta: { roles: ['user'], title: 'Pelit' },
    component: () => import (/* webpackChunkName: "videos" */ '../views/Games.vue'),
  },
  {
    path: '/reports',
    name: 'Reports',
    children: [
    ],
    meta: { roles: ['user'], title: 'Raportit' },
    component: () => import (/* webpackChunkName: "videos" */ '@/views/Reports.vue'),
  },
  {
    path: '/reports/create',
    component: () => import (/* webpackChunkName: "videos" */ '@/components/report/CreateReport.vue'),
    meta: {
      roles: ['tiimi-admin']
    }
  },
  {
    path: '/tiimi-admin',
    name: 'TiimiAdmin',
    children: [
      {
        path: 'maps',
        component: () =>
          import ('@/components/tiimi_admin/AdminMaps.vue'),
        meta: {
          roles: ['tiimi-admin'],
          availableWithNoTeams: false
        }
      },
      {
        path: 'sports',
        component: () =>
          import ('@/components/tiimi_admin/AdminSports.vue'),
        meta: {
          roles: ['tiimi-admin'],
          availableWithNoTeams: false
        }
      },
      {
        path: 'sports/:sport_id',
        component: () =>
          import ('@/components/tiimi_admin/Sport.vue'),
        meta: {
          roles: ['tiimi-admin'],
          availableWithNoTeams: false
        },
        children: [
          {
            path: 'tags',
            component: () =>
              import ('@/components/tiimi_admin/sport/SportTags.vue'),
            meta: {
              roles: ['tiimi-admin'],
              availableWithNoTeams: false
            },
          },
          {
            path: 'templates',
            component: () =>
              import ('@/components/tiimi_admin/sport/SportTemplates.vue'),
            meta: {
              roles: ['tiimi-admin'],
              availableWithNoTeams: false
            },
          },
        ]
      },
      {
        path: 'leagues',
        component: () =>
          import ('@/components/tiimi_admin/AdminLeagues.vue'),
        meta: {
          roles: ['tiimi-admin'],
          availableWithNoTeams: false
        }
      },
      {
        path: 'leagues/:league_id',
        component: () =>
          import ('@/components/tiimi_admin/League.vue'),
        meta: {
          roles: ['tiimi-admin'],
          availableWithNoTeams: false
        },
        children: [
          {
            path: 'games',
            component: () =>
              import ('@/components/tiimi_admin/league/LeagueGames.vue'),
            meta: {
              roles: ['tiimi-admin'],
              availableWithNoTeams: false
            },
          },
          {
            path: 'tags',
            component: () =>
              import ('@/views/Tags.vue'),
            meta: {
              roles: ['tiimi-admin'],
              availableWithNoTeams: false
            },
          },
          {
            path: 'tag-views',
            component: () =>
              import ('@/components/tag_views/TagViews.vue'),
            meta: {
              roles: ['tiimi-admin'],
              availableWithNoTeams: false
            },
            props: route => ({
              league_id: route.params.league_id
            })
          },
          {
            path: 'teams',
            component: () =>
              import ('@/components/tiimi_admin/league/LeagueTeams.vue'),
            meta: {
              roles: ['tiimi-admin'],
              availableWithNoTeams: false
            },
          },
          {
            path: 'clubs',
            component: () =>
              import ('@/components/tiimi_admin/league/LeagueClubs.vue'),
            meta: {
              roles: ['tiimi-admin'],
              availableWithNoTeams: false
            },
          },
          {
            path: 'seasons',
            component: () =>
              import ('@/components/tiimi_admin/league/LeagueSeasons.vue'),
            meta: {
              roles: ['tiimi-admin'],
              availableWithNoTeams: false
            },
          },
          {
            path: 'configuration',
            component: () =>
              import ('@/components/tiimi_admin/league/LeagueConfiguration.vue'),
            meta: {
              roles: ['tiimi-admin'],
              availableWithNoTeams: false
            },
          },
          {
            path: 'players',
            component: () =>
              import ('@/components/tiimi_admin/league/LeaguePlayers.vue'),
            meta: {
              roles: ['tiimi-admin'],
              availableWithNoTeams: false
            },
          },
          {
            path: 'stadions',
            component: () =>
              import ('@/components/tiimi_admin/league/LeagueStadions.vue'),
            meta: {
              roles: ['tiimi-admin'],
              availableWithNoTeams: false
            },
          },
          {
            path: 'referees',
            component: () =>
              import ('@/components/tiimi_admin/league/LeagueReferees.vue'),
            meta: {
              roles: ['tiimi-admin'],
              availableWithNoTeams: false
            },
          },
          {
            path: 'league_maps',
            component: () =>
              import ('@/components/tiimi_admin/league/LeagueMaps.vue'),
            meta: {
              roles: ['tiimi-admin'],
              availableWithNoTeams: false
            },
          },
          {
            path: 'runs',
            component: () =>
              import ('@/components/tiimi_admin/league/LeagueRuns.vue'),
            meta: {
              roles: ['tiimi-admin'],
              availableWithNoTeams: false
            },
          },
        ]
      },
      {
        path: 'analyzers',
        component: Analyzers,
        meta: {
          roles: ['tiimi-admin'],
          availableWithNoTeams: false
        }
      },
      {
        path: 'laaturaportti',
        component: () => import('@/views/Laaturaportti.vue'),
        meta: {
          roles: ['tiimi-admin'],
          availableWithNoTeams: false,
          hideNavBar: true,
          mini: true,
        }
      },
      {
        path: 'teams',
        component: () =>
          import ('@/components/tiimi_admin/Teams.vue'),
        meta: {
          roles: ['tiimi-admin']
        }
      },
      {
        path: 'import',
        component: () =>
          import ('@/components/tiimi_admin/Import.vue'),
        meta: {
          roles: ['tiimi-admin']
        }
      },
      {
        path: 'autoimport',
        component: () =>
          import ('@/components/tiimi_admin/AutoImport.vue'),
        meta: {
          roles: ['tiimi-admin']
        }
      },
      {
        path: 'feedback',
        component: () =>
          import ('@/components/tiimi_admin/AdminFeedback.vue'),
        meta: {
          roles: ['tiimi-admin']
        }
      },
      {
        path: 'self-uploaded-videos',
        component: () =>
          import ('@/components/tiimi_admin/SelfUploadedVideos.vue'),
        meta: {
          roles: ['tiimi-admin'],
          allowedEmails: ['aku@kettunen.com']
        }
      },
      {
        path: 'quality-control',
        component: QualityControl,
        meta: {
          roles: ['super-admin'],
          availableWithNoTeams: false,
        }
      }
    ],
    meta: { roles: ['tiimi-admin'] },
    component: () => import (/* webpackChunkName: "videos" */ '../views/TiimiAdmin.vue'),
  },
  {
    path: '/create-sport-template/:sport_id',
    name: 'Create sport ButtonTemplate route',
    meta: {
      roles: ['tiimi-admin'],
      availableWithNoTeams: false,
      hideNavBar: true,
      hideSideBar: true
    },
    component: () => import (/* webpackChunkName: "videos" */ '../components/buttontemplate/Create.vue'),
  },
  {
    path: '/create-team-template',
    name: 'Create sport ButtonTemplate',
    meta: {
      roles: ['user'],
      availableWithNoTeams: false,
      hideNavBar: true,
      hideSideBar: true
    },
    component: () => import (/* webpackChunkName: "videos" */ '../components/buttontemplate/Create.vue'),
  },
  {
    path: '/edit-button-template/:template_id/sport/:sport_id',
    name: 'Edit sport ButtonTemplate',
    meta: {
      roles: ['tiimi-admin'],
      availableWithNoTeams: false,
      hideNavBar: true,
      hideSideBar: true
    },
    component: () => import (/* webpackChunkName: "videos" */ '../components/buttontemplate/Create.vue'),
  },
  {
    path: '/edit-button-template/:template_id/team',
    name: 'Edit sport ButtonTemplate team',
    meta: {
      roles: ['user'],
      availableWithNoTeams: false,
      hideNavBar: true,
      hideSideBar: true
    },
    component: () => import (/* webpackChunkName: "videos" */ '../components/buttontemplate/Create.vue'),
  },
  {
    path: '/confirm/:code',
    name: 'Confirm',
    children: [],
    meta: {
      roles: ['all'],
      availableWithNoTeams: true
    },
    component: () => import (/* webpackChunkName: "videos" */ '../views/Confirm.vue'),
  },
  {
    path: '/filters',
    name: 'Filters',
    children: [],
    meta: { roles: ['user'], title: 'Suodatukset' },
    component: () => import (/* webpackChunkName: "filters" */ '../views/Filters.vue'),
  },
  {
    path: '/editor',
    name: 'Editor',
    children: [],
    meta: { roles: ['user'], hideNavBar: true, mini: true },
    component: () => import (/* webpackChunkName: "filters" */ '../components/video/ClipEditor/Editor.vue'),
  },
  {
    path: '/filter/:id',
    name: 'Filter',
    children: [],
    meta: { roles: ['user'], hideNavBar: true, mini: true,  },
    component: () => import (/* webpackChunkName: "filter" */ '../views/Filter.vue'),
  },
  {
    path: '/filter/library/:id',
    name: 'Filterplay',
    children: [],
    meta: { roles: ['user'], hideNavBar: true, mini: true },
    component: () => import (/* webpackChunkName: "filter" */ '../views/Filter.vue'),
  },
  {
    path: '/confirm-email',
    name: 'ConfirmEmail',
    meta: {
      roles: ['all'],
      availableWithNoTeams: true,
      availableWithNoConfirmation: true,
      hideSideBar: true,
      showNavOnMobile: true
    },
    component: () => import ('@/views/ConfirmEmail.vue'),
  },
  {
    path: '/team',
    name: 'Join',
    meta: {
      roles: ['all'],
      availableWithNoTeams: true,
      showNavOnMobile: true
    },
    children: [
      {
        path: 'options',
        component: () =>
          import ('@/components/team/Options.vue'),
        meta: {
          roles: ['all'],
          availableWithNoTeams: true,
          hideSideBar: true,
          showNavOnMobile: true
        }
      },
      {
        path: 'join',
        component: () =>
          import ('@/components/team/Join.vue'),
        meta: { roles:
          ['all'],
          availableWithNoTeams: true,
          hideSideBar: true,
          showNavOnMobile: true
        }
      },
      {
        path: 'create',
        component: () =>
          import ('@/components/team/Create.vue'),
        meta: {
          roles: ['all'],
          availableWithNoTeams: true,
          showNavOnMobile: true
        }
      }
    ],
    component: () => import ('@/views/Team.vue'),
  },
  {
    path: '/newteam',
    name: 'NewTeam',
    children: [],
    meta: { roles: ['all'] },
    component: () => import ('@/views/NewTeam.vue'),
  },
  // {
  //   path: '/maps',
  //   name: 'Maps',
  //   children: [],
  //   meta: { roles: ['user'] },
  //   component: () => import ('@/views/Maps.vue'),
  // },
  {
    path: '/buttontemplate',
    name: 'Template',
    children: [
      {
        path: 'create',
        meta: { roles: ['user'], hideNavBar: true },
        component: () =>
          import ('@/components/buttontemplate/Create.vue'),
      }
    ],
    meta: { roles: ['user'] },
    component: () => import ('@/components/buttontemplate/Create.vue'),
  },
  {
    path: '/reset/:code',
    name: 'Reset',
    children: [],
    meta: {
      roles: ['all'],
      hideSideBar: true,
      availableWithNoTeams: true,
      availableWithNoConfirmation: true,
    },
    component: () => import ('@/views/Reset.vue'),
  },
  {
    path: '/videos/:id',
    name: 'Video',
    children: [],
    meta: { roles: ['user'], hideNavBar: true, mini: true },
    component: () => import ('@/views/Video.vue'),
  },
  {
    path: '/analysis/:id',
    name: 'Video - Analysis',
    children: [],
    meta: { roles: ['tiimi-admin', 'league-admin'], hideNavBar: true, mini: true },
    component: () => import ('@/views/Video.vue'),
  },
  {
    path: '/games/:id',
    name: 'Game',
    children: [],
    meta: { roles: ['user'], hideNavBar: true, mini: true },
    component: () => import ('@/views/Video.vue'),
  },
  {
    path: '/external',
    name: 'External Game Redirect',
    meta: { roles: ['user'] },
    component: () => import('@/components/ExternalGameRedirect.vue'),
  },
  {
    path: '/about',
    name: 'About',
    meta: { roles: ['all']},
    component: () => import(/* webpackChunkName: "about" */ '../views/Videos.vue')
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      roles: ['all'],
      hideNavBar: true,
      hideSideBar: true,
      notLoggedIn: true,
    },
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/signin',
    name: 'Signin',
    meta: {
      roles: ['all'],
      hideNavBar: true,
      hideSideBar: true,
      notLoggedIn: true
    },
    component: () => import(/* webpackChunkName: "signin" */ '../views/Signin.vue')
  },
  {
    path: '/popout/video/:id',
    name: 'Popout',
    meta: {
      roles: ['user'],
      hideNavBar: true,
      hideSideBar: true,
      notLoggedIn: false
    },
    component: () => import(/* webpackChunkName: "signin" */ '../components/ticks/Popout.vue')
  },
  {
    path: '/settings',
    name: 'Settings',
    meta: {
      roles: ['user'],
      hideNavBar: false,
      hideSideBar: false,
      availableWithNoTeams: true,
      availableWithNoConfirmation: true,
      showNavOnMobile: true,
      title: 'Asetukset'
    },
    component: () => import(/* webpackChunkName: "settings" */ '../views/Settings.vue')
  },
  // {
  //   path: '/share/:code',
  //   name: 'Share',
  //   meta: {
  //           roles: ['all'],
  //           hideNavBar: true,
  //           hideSideBar: true,
  //           // notLoggedIn: true
  //         },
  //   component: () => import(/* webpackChunkName: "plans" */ '../views/Share.vue')
  // },
  {
    path: '/admin',
    name: 'Admin',
    meta: { roles: ['admin'] },
    children: [
      {
        path: 'team',
        component: () =>
          import ('@/components/admin/Team.vue'),
        meta: { roles: ['admin'] }
      }
    ],
    component: () => import (/* webpackChunkName: "admin" */ '../views/Admin.vue'),
  },
  {
    path: '/tags',
    name: 'TagViews',
    meta: { roles: ['user'] },
    component: () => import (/* webpackChunkName: "tags" */ '../components/tag_views/TagViews.vue'),
  },
  {
    path: '/tag-views',
    name: 'Tags',
    meta: { roles: ['user'] },
    component: () => import (/* webpackChunkName: "tags" */ '../components/tag_views/TagViews.vue'),
  },
  {
    path: '/refresh',
    name: 'Refresh',
    meta: {
      roles: ['user']
    },
    component: () => import (/* webpackChunkName: "refresh" */ '../views/Refresh.vue'),
  },
  {
    path: '/forgot',
    name: 'Forgot',
    meta: {
      roles: ['all'],
      notLoggedIn: true,
      hideSideBar: true,
    },
    component: () => import (/* webpackChunkName: "refresh" */ '../views/Forgot.vue'),
  },
  {
    path: '/library',
    name: 'Library',
    meta: { roles: ['user'], title: 'Kirjasto' },
    component: () => import (/* webpackChunkName: "library" */ '../views/Library.vue'),
  },
  {
    path: '/presentation/:id',
    name: 'Esitelmä',
    meta: {
      roles: ['user'],
      hideSideBar: true,
      hideNavBar: true,
    },
    component: () => import (/* webpackChunkName: "presentation" */ '../views/Presentation.vue'),
  },
  {
    path: '/times',
    name: 'Ajat',
    meta: { roles: ['user'] },
    component: () => import (/* webpackChunkName: "times" */ '../views/Times.vue'),
  },
  {
    path: '/streaming',
    name: 'Striimaus',
    meta: {
      roles: ['user'],
      hideNavBar: true,
   },
    component: () => import ( /* webpackChunkName: "streaming" */ '../views/Streaming.vue'),
    beforeEnter: (to, _, next) => {
      const token = window.localStorage.getItem('tiimio-token') || to.query.token
      const decoded_token = jwt.decode(token)
      const currentTeam = decoded_token?.teams?.find(t => t.id == Number(decoded_token?.currentTeamId))
      if(currentTeam.streaming_enabled == 0) next('/videos')
      else next()
    }
  },
  {
    path: '/streaming/mobile',
    name: 'mobileStream',
    meta: {
      roles: ['user'],
      hideNavBar: true,
      hideSideBar: true,
    },
    component: () => import ( /* webpackChunkName: "streaming" */ '../views/Streaming.vue'),
    beforeEnter: (to, _, next) => {
      const token = window.localStorage.getItem('tiimio-token') || to.query.token
      const decoded_token = jwt.decode(token)
      const currentTeam = decoded_token?.teams?.find(t => t.id == Number(decoded_token?.currentTeamId))
      if(currentTeam.streaming_enabled == 0) next('/videos')
      else next()
    }
  },
  {
    path: '/team-closed',
    name: 'TeamClosed',
    meta: {
      roles: ['user'],
      hideSideBar: true,
      availableWithNoTeams: true
    },
    component: () => import (/* webpackChunkName: "team-closed" */ '../views/TeamClosed.vue'),
  },
  {
    path: '/exports',
    name: 'Exports',
    meta: { roles: ['user'] },
    component: () => import (/* webpackChunkName: "exports" */ '../views/Exports.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(( to, from, next ) => {
  const token = window.localStorage.getItem('tiimio-token') || to.query.token
  const decoded_token = jwt.decode(token)
  // if the user has no token lets go to login
  if((!token || !decoded_token) &&  !to.meta.roles?.includes('all') && to.path !== '/login') {
    return next({ path: '/login', query: { ref: to.fullPath } })
  }

  const currentTeam = decoded_token?.teams?.find(t => t.id == Number(decoded_token?.currentTeamId))
  // Set dynamic page title
  setTitleFromRoute(to)

  const defaultPath = currentTeam?.league_id ? '/games' : '/videos'

  // const current_team_id = decoded_token?.currentTeamId
  // const current_team_object = decoded_token?.teams?.find(t => t.id == current_team_id)
  // const current_plan_id = current_team_object?.plan_id

  // if token is expired you'll need to login again
  // if(expired && !to.meta.roles?.includes('all') && to.path != '/login') {
  //   return next( { path: '/login', query: {exp: true, ref: to.fullPath} } )
  // }

  /* ROUTES NEEDING AUTHENTICATION */

  // going to signin with a join code
  if(to.path == '/signin' && to.query.invite_code && !!decoded_token) {
    return next({ path: '/team/join', query: { invite_code: to.query.invite_code } })
  }

  // if user hasn't confirmed email go to confirmation
  if(token && !decoded_token.email_confirmed) {
    if(to.meta.availableWithNoConfirmation) next()
    else next({ path: '/confirm-email' })
    return
  }

  // if user has no teams lets go to join
  if(token && !decoded_token.teams.length) {
    if(to.meta.availableWithNoTeams) next()
    else next({ path: '/team/options' })
    return
  }

  // if current team is closed, redirect to team closed page
  if(token && currentTeam && (currentTeam.closed === 1 || currentTeam.closed === true) && to.path !== '/team-closed' && !to.meta.availableWithNoTeams) {
    return next({ path: '/team-closed' })
  }

  // has token and has teams, lets not go to routes login and signin
  if(token && to.meta.notLoggedIn) {
    return next({ path: defaultPath })
  }

  // if only for admin then check it
  if(to.meta.roles?.includes('league-admin') && !currentTeam.league_admin && !decoded_token.tiimio_admin) {
    return next({ path: defaultPath })
  }

  // if only for admin then check it
  if(to.meta.roles?.includes('tiimi-admin') && !decoded_token.tiimio_admin) {
    return next({ path: defaultPath })
  }

  // if only for super admin then check it
  if(to.meta.roles?.includes('super-admin') && !decoded_token.super_admin) {
    return next({ path: defaultPath })
  }

  if(to.meta.allowedEmails && !to.meta.allowedEmails.includes(decoded_token.email?.toLowerCase())) {
    return next({ path: defaultPath })
  }

  if(to.path == '/') {
    return next({ path: defaultPath })
  }

  /* if team has no plan let's go to plans!
     without a plan you're allowed to go to
      - notLoggedIn paths
      - create team
      - join team
      - settings
      - refresh (important)
      - reset
      - AND PLANS :D
  */

    //   if(
    // (!current_plan_id)
    // &&
    // ( !['/settings', '/team/create', '/team/options', '/team/join', '/signin', '/login', '/forgot', '/plans', '/refresh', '/reset'].includes(to.path) )
    // && !decoded_token?.tiimio_admin
    // && !to.path.includes('/reset')
    // ) {
    //   return next({ path: '/plans' })
    // }
  // alls good lets go where we wanted

  // handle stuff for mobile app
  const message = JSON.stringify({
    route: to.path
  });

  try {
    window?.ReactNativeWebView?.postMessage(message);
  } catch(e) {
    console.log(e)
  }

  try {
    document?.ReactNativeWebView?.postMessage(message);
  } catch(e) {
    console.log(e)
  }

  // Track page views for analytics
  if (to.meta.track !== false) { // Allow routes to opt-out of tracking
    // Store route info for tracking after component mount
    window.__pendingRouteTrack = {
      page_name: to.name || to.path,
      page_path: to.path,
      page_full_path: to.fullPath,
      from_page: from.name || from.path,
      query_params: Object.keys(to.query).length > 0 ? to.query : undefined
    }
  }

  next()
})

export default router
